import Filter from 'bad-words';
var profanityFilter = new Filter();
var whiteListWords = [
    'balls',
    'breasts'
];
profanityFilter.removeWords.apply(profanityFilter, whiteListWords);
export { profanityFilter };
